// 容器状态
export const containerState = {
  // 表单
  FORM: 'form',
  // 聊天
  CHAT_WIDGET: 'chat',
  // 视频
  VIDEO: 'video',
  // 联系
  CONTACT: 'contact',
  // 联系详情
  CONTACT_DETAIL: 'contact_detail',
};

// 渠道类型
export const channelState = {
  // 知识库
  KNOWLEDGE: 'KNOWLEDGE',
  // connect
  CONNECT: 'CONNECT',
  // im-chat
  IM_CHAT: 'IM_CHAT',
};

// 消息角色类型
export const messageRole = {
  // 知识库
  KNOWLEDGE: 'KNOWLEDGE',
  // CONNECT-坐席
  AGENT: 'AGENT',
  // CONNECT-客户
  CUSTOMER: 'CUSTOMER',
  // AI-Agent
  AIAGENT: 'AIAGENT',
};

// 手机端摄像头模式
export const facingMode = {
  // 前置
  USER: 'user',
  // 后置
  ENVIRONMENT: 'environment',
};

// 消息类型
export const messageDateType = {
  // 消息
  MESSAGE: 'MESSAGE',
  // 系统事件
  EVENT: 'EVENT',
  // 满意度评分
  EVALUATION: 'EVALUATION',
  // 分隔符
  DIVIDER: 'DIVIDER',
};
